import React from 'react';
import { useTranslation } from 'react-i18next';
import DiscountTable from './discountTable';

export default function PreviewGenerateCode({ discounts = [], discounts_list = [] }) {
    const { t } = useTranslation();
    return (
        <div>
            <DiscountTable discounts={discounts} discounts_list={discounts_list} readOnly={true} />
            {`${discounts.length} ${t('ticket.common.discount', {
                count: discounts.length
            })}`}
        </div>
    );
}
